import * as React from "react";
import {
  Box,
  Container,
  Grid,
  TextField,
  Typography,
  FormControl,
  Paper,
  Stack,
  InputAdornment,
  IconButton,
  Fade,
  Slide,
} from "@mui/material";

import { resetPasswordAPI, pinResetAPI } from "../config";

import axios from "axios";
import { useState, useRef, useEffect } from "react";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as Yup from "yup";
import { AlertMessage } from "../components/AlertMessage";

import { useAuthContext } from "../hooks/useAuthContext";
import "../assets/css/login.css";
import loginBackgroundImage from "../assets/images/login/LMGGT.png";
import { LoadingButton } from "@mui/lab";
import { useNavigate } from "react-router-dom";
import {
  config,
  loginAPI,
  resetPasswordEmailAPI,
  verifyOTPAPI,
} from "../config";
import moment from "moment";
import { getDefaultPage } from "../components/HelperFile";
import { apiData } from "../services/api_service";
import LockOutlinedIcon from "@mui/icons-material/LockOutlined";
import EmailOutlinedIcon from "@mui/icons-material/EmailOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";

// Same company logo used in the dashboard sidebar (see layout/Layout.jsx)
const companyLogo =
  "https://pfb3tybxnslu7y2e.public.blob.vercel-storage.com/uploads/LMGG%20%281%29-TqX3f1IBK8HeRMUjihBXaklxEG3AsJ.png";

export default function AdminLogin() {
  const { dispatch } = useAuthContext();
  const [successLoginFlag, setSuccessLoginFlag] = React.useState(false);
  const [projectDetails, setProjectDetails] = React.useState([]);
  const [forgotPasswordEmail, setForgotPasswordEmail] = useState("");

  const [isForgotPin, setIsForgotPin] = React.useState([]);

  const handleForgotPin = () => {
    setIsForgotPin(!isForgotPin);
  };

  const [otp, setOtp] = useState(new Array(4).fill(""));
  const navigate = useNavigate();
  const [newPin, setNewPin] = useState(["", "", "", ""]);
  const [errMessage, setErrMessage] = useState("");
  const [isForgotPassword, setIsForgotPassword] = useState(false);
  const [isSendOTP, setIsSendOTP] = useState(false);
  const [intOTP, setOTP] = useState("");
  const [isVerifiedOTP, setIsVerifiedOTP] = useState(false);

  const handlePinBackspace = (event, index) => {
    if (event.key === "Backspace") {
      if (otp[index]) {
        // Clear current box
        const newArr = [...otp];
        newArr[index] = "";
        setOtp(newArr);
      } else if (index > 0) {
        // Move to previous box and clear it
        const prevArr = [...otp];
        prevArr[index - 1] = "";
        setOtp(prevArr);
        const prevInput = document.getElementsByName("otp")[index - 1];
        if (prevInput) prevInput.focus();
      }
      event.preventDefault();
    }
  };

  const handlePaste = (event, startIndex, fieldName) => {
    event.preventDefault();

    const pastedData = event.clipboardData.getData("Text").slice(0, 4);
    if (!/^\d+$/.test(pastedData)) return; // Only digits allowed

    // Update the correct input array (otp or newPin)
    let updatedArray;
    if (fieldName === "otp") {
      updatedArray = [...otp];
    } else {
      updatedArray = [...newPin];
    }

    for (let i = 0; i < pastedData.length; i++) {
      if (startIndex + i < updatedArray.length) {
        updatedArray[startIndex + i] = pastedData[i];
      }
    }

    if (fieldName === "otp") {
      setOtp(updatedArray);
      // Focus last pasted field or next one if applicable
      const nextIndex = Math.min(
        startIndex + pastedData.length,
        otp.length - 1
      );
      const input = document.getElementsByName("otp")[nextIndex];
      if (input) input.focus();
    } else {
      setNewPin(updatedArray);
      const nextIndex = Math.min(
        startIndex + pastedData.length,
        newPin.length - 1
      );
      const input = document.getElementsByName("newPin")[nextIndex];
      if (input) input.focus();
      handleChangesubmit(event.target, startIndex + pastedData.length - 1);
    }
  };

  useEffect(() => {
    const user = JSON.parse(localStorage.getItem("user"));
    if (user) {
      const pageURL = getDefaultPage(user);
      navigate(pageURL);
    }
  }, []);

  const validationSchema = Yup.object().shape({
    txtPassword: Yup.string().required("Password is required"),
    txtEmail: Yup.string()
      .required("Email is required")
      .email("Please enter valid email format"),
  });

  const formOptions = { resolver: yupResolver(validationSchema) };

  const { register, handleSubmit, reset, formState } = useForm(formOptions);

  const { errors } = formState;

  const handleSendOTP = () => {
    setErrMessage("");
    if (
      !/^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,4}$/i.test(forgotPasswordEmail)
    ) {
      setErrMessage("Please enter valid email");
      return false;
    }

    var reqData = JSON.stringify({
      txtUsername: forgotPasswordEmail,
      intType: 5,
    });
    config.method = "post";
    config.url = resetPasswordEmailAPI;
    config.data = reqData;

    // debugger;
    axios(config)
      .then(function (response) {
        if (response.data.message === "Invalid Email") {
          setErrMessage(response.data.message);
        } else {
          setIsSendOTP(!isSendOTP);
        }
      })
      .catch(function (error) {
        if (error.message === "Network Error") {
          localStorage.removeItem("user");
          window.location.href = window.location.origin + "/";
        }
        console.log(error);
        setErrMessage("Please Enter Valid Email ID");
      });
  };

  const handleVerifyOTP = async () => {
    try {
      var reqData = JSON.stringify({
        txtUsername: forgotPasswordEmail,
        intType: 9,
        intOTP: intOTP,
      });
      config.method = "post";
      config.url = verifyOTPAPI;
      config.data = reqData;

      const response = await apiData("post", verifyOTPAPI, reqData);
      if (response?.msg === "Invalid Otp") {
        setErrMessage(response.msg);
      } else {
        setIsVerifiedOTP(!isVerifiedOTP);
        setErrMessage("");
      }
    } catch (error) {
      console.log(error);
      if (error?.message === "Network Error") {
        localStorage.removeItem("user");
        window.location.href = window.location.origin + "/";
      }
      console.log(error);
      setErrMessage("Invalid Username or Password");
    }
  };

  const handleChangesubmit = async (element, index) => {
    if (isNaN(element.value)) return false;

    setOtp([...otp.map((d, idx) => (idx === index ? element.value : d))]);

    //Focus next input
    if (element.nextSibling) {
      element.nextSibling.focus();
    }

    if (index == 3) {
      const pinarr = [
        ...otp.map((d, idx) => (idx === index ? element.value : d)),
      ];
      let loginpin = "";
      pinarr.map(function (x) {
        loginpin += x;
      });

      const data = {
        intPin: parseInt(loginpin),
        txtDate: moment().format("YYYY-MM-DD"),
      };

      config.method = "POST";
      config.data = JSON.stringify(data);
      config.url = loginAPI;

      await axios(config)
        .then(async function (response) {
          if (
            response.data.message === "SUCCESS" &&
            Array.isArray(response.data.result) &&
            response.data.result[0]
          ) {
            //Remove existing local storage
            localStorage.removeItem("isProjectLoggedIn");
            localStorage.removeItem("projectID");
            localStorage.removeItem("projectAutoID");
            localStorage.removeItem("projectName");
            localStorage.removeItem("projectCheckInTime");
            localStorage.removeItem("userAttandenceLogin");
            if (
              response.data.result[1] &&
              response.data.result[1].working_hours == ""
            ) {
              if (
                !response.data.result[1].end_time ||
                (response.data.result[1].end_time = "0000-00-00 00:00:00")
              ) {
                localStorage.setItem("isProjectLoggedIn", true);
                localStorage.setItem(
                  "projectID",
                  response.data.result[1].project_id
                    ? response.data.result[1].project_id
                    : 0
                );
                localStorage.setItem(
                  "projectAutoID",
                  response.data.result[1].id ? response.data.result[1].id : 0
                );
                localStorage.setItem(
                  "projectName",
                  response.data.result[1].project_name
                    ? response.data.result[1].project_name
                    : ""
                );
                localStorage.setItem(
                  "projectCheckInTime",
                  response.data.result[1].start_time
                    ? response.data.result[1].start_time
                    : ""
                );
                localStorage.setItem("userAttandenceLogin", "true");
              }
            }

            setProjectDetails(response.data.result[1]);
            setSuccessLoginFlag(true);

            let responseData = response.data.result[0];
            localStorage.setItem("user", JSON.stringify(responseData));
            dispatch({ type: "LOGIN", payload: "jsonData" });

            const pageURL = getDefaultPage(responseData);
            if (pageURL && pageURL !== "/") {
              window.location.href = pageURL;
            } else {
              localStorage.removeItem("user");
              dispatch({ type: "LOGOUT" });
              setErrMessage("Your account has no access to any page.");
              setOtp([...otp.map((v) => "")]);
            }
          } else {
            setErrMessage(
              response.data.message || "Invalid PIN or profile deactivated."
            );
            setOtp([...otp.map((v) => "")]);
          }
        })
        .catch(function (error) {
          const apiMessage =
            error.response?.data?.message || "Something went wrong. Try again.";

          childRef.current.triggerAlert(
            JSON.stringify({
              message: apiMessage,
              messageType: "error",
            })
          );

          // reset PIN boxes
          setOtp([...otp.map((v) => "")]);
          const firstInput = document.getElementsByName("otp")[0];
          if (firstInput) firstInput.focus();
        });

    }
  };

  const handleChangeNewPin = (target, index) => {
    if (isNaN(target.value)) return false; // only digits allowed
    let value = target.value;

    // update current index
    const updatedPin = [...newPin];
    updatedPin[index] = value;
    setNewPin(updatedPin);

    // move to next field
    if (value !== "" && target.nextSibling) {
      target.nextSibling.focus();
    }
  };

  const handleSubmitNewPin = async () => {
    const pinValue = newPin.join("");
    if (pinValue.length !== 4) {
      setErrMessage("Please enter a valid 4-digit PIN");
      return;
    }

    try {
      const payload = {
        txtUsername: forgotPasswordEmail,
        txtOTP: intOTP,
        intPin: pinValue,
      };

      const response = await apiData("post", pinResetAPI, payload);

      if (response?.success) {
        childRef.current.triggerAlert(
          JSON.stringify({
            message: "PIN Reset Successfully!",
            messageType: "success",
          })
        );
        setErrMessage("");
        setTimeout(() => window.location.reload(), 2000);
      } else {
        setErrMessage(response?.msg || "Failed to reset PIN");
      }
    } catch (error) {
      console.error("Error resetting PIN:", error);
      const errorMessage =
        error.response?.data?.msg ||
        error.response?.data?.error ||
        error.msg ||
        "Something went wrong. Try again.";

      setErrMessage(errorMessage);
    }
  };

  const childRef = useRef();

  return (
    <>
      <AlertMessage ref={childRef} />
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          background: "rgba(154,39,40,0.06)",
        }}
      >
        <Container maxWidth="lg" sx={{ my: "auto" }}>
          <Fade in={true} timeout={800}>
            <Paper
              elevation={24}
              sx={{
                borderRadius: 4,
                overflow: "hidden",
                background: "#ffffff",
              }}
            >
              {/* Mobile simplified view: logo + PIN only (shown on <=768px / <=425px) */}
              <Box className="mobile-login" sx={{ display: "none", p: 4 }}>
                <Box sx={{ textAlign: "center", mb: 3 }}>
                  <Box
                    component="img"
                    className="logo-image"
                    src={companyLogo}
                    alt="LMGGT logo"
                    sx={{ maxWidth: 220 }}
                  />
                </Box>
                <Box sx={{ textAlign: "center" }}>
                  <Stack direction="row" spacing={1} justifyContent="center">
                    {otp.map((data, index) => (
                      <input
                        className="otp-field"
                        type="text"
                        name="otp"
                        maxLength="1"
                        key={index}
                        value={data}
                        clearinput
                        onChange={(e) => handleChangesubmit(e.target, index)}
                        onFocus={(e) => e.target.select()}
                        onKeyDown={(e) => handlePinBackspace(e, index)}
                        onPaste={(e) => handlePaste(e, index, "otp")}
                      />
                    ))}
                  </Stack>
                  {errMessage && (
                    <Typography
                      color="error"
                      variant="body2"
                      sx={{ mt: 2, textAlign: "center" }}
                    >
                      {errMessage}
                    </Typography>
                  )}
                </Box>
              </Box>
              <Grid container className="desktop-login">
                {/* LEFT SIDE (LOGO + IMAGE) - plain white */}
                <Grid
                  item
                  xs={12}
                  md={5}
                  sx={{
                    background: "#ffffff",
                    display: "flex",
                    flexDirection: "column",
                    alignItems: "center",
                    justifyContent: "center",
                    p: 6,
                    color: "inherit",
                  }}
                >
                  <Slide direction="right" in={true} timeout={600}>
                    <Box sx={{ textAlign: "center" }}>
                      <Box
                        component="img"
                        className="logo-image"
                        src={companyLogo}
                        alt="LMGGT logo"
                        sx={{ maxWidth: "270px", mb: 6 }}
                      />
                      <Box
                        component="img"
                        className="login-illustration"
                        src={loginBackgroundImage}
                        alt="Login illustration"
                        sx={{
                          maxWidth: "280px",
                          opacity: 0.9,
                        }}
                      />

                      {/* <Typography 
                        variant="body2" 
                        sx={{ 
                          mt: 2, 
                          color: "#000000b5",
                          cursor: "pointer", 
                          opacity: 0.9 
                        }}  
                      >
                        <u>LMGGT.com</u>
                      </Typography> */}
                    </Box>
                  </Slide>
                </Grid>

                {/* RIGHT SIDE (FORM CONTENT) - brand background */}
                <Grid
                  item
                  xs={12}
                  md={7}
                  className="right-panel"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    p: { xs: 4, md: 6 },
                    background:
                      "linear-gradient(135deg, rgba(154,39,40,0.95) 0%, rgba(120,30,30,0.9) 100%)",
                    color: "#ffffff",
                  }}
                >
                  <Box sx={{ width: "100%", maxWidth: 420 }}>
                    {isVerifiedOTP ? (
                      <Fade in={true}>
                        <Box>
                          <Box sx={{ textAlign: "center", mb: 4 }}>
                            <CheckCircleOutlineIcon
                              sx={{
                                fontSize: 56,
                                color: "success.main",
                                mb: 2,
                              }}
                            />
                            <Typography
                              variant="h5"
                              fontWeight={600}
                              gutterBottom
                            >
                              Set New PIN
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Enter your new 4-digit PIN below
                            </Typography>
                          </Box>
                          <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="center"
                            sx={{ mb: 4 }}
                          >
                            {newPin.map((data, index) => {
                              return (
                                <input
                                  className="otp-field"
                                  type="text"
                                  name="newPin"
                                  maxLength="1"
                                  key={index}
                                  value={data}
                                  clearinput
                                  onChange={(e) =>
                                    handleChangeNewPin(e.target, index)
                                  }
                                  onFocus={(e) => e.target.select()}
                                  onKeyDown={(e) =>
                                    handlePinBackspace(e, index)
                                  }
                                  onPaste={(e) => handlePaste(e, index, "otp")}
                                />
                              );
                            })}
                          </Stack>

                          {errMessage && (
                            <Typography
                              color="error"
                              variant="body2"
                              sx={{ mb: 2, textAlign: "center" }}
                            >
                              {errMessage}
                            </Typography>
                          )}

                          <LoadingButton
                            fullWidth
                            size="large"
                            variant="contained"
                            onClick={handleSubmitNewPin}
                            disabled={formState.isSubmitting}
                            sx={{
                              py: 1.5,
                              textTransform: "none",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                          >
                            Submit
                          </LoadingButton>
                        </Box>
                      </Fade>
                    ) : isSendOTP ? (
                      <Fade in={true}>
                        <Box>
                          <IconButton
                            onClick={() => setIsSendOTP(false)}
                            sx={{ mb: 2 }}
                          >
                            <ArrowBackIcon />
                          </IconButton>
                          <Box sx={{ mb: 4 }}>
                            <Typography
                              variant="h5"
                              fontWeight={600}
                              gutterBottom
                            >
                              Verify OTP
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Enter the OTP sent to {forgotPasswordEmail}
                            </Typography>
                          </Box>
                          <TextField
                            name="txtEmail"
                            type="text"
                            label="Enter OTP"
                            fullWidth
                            sx={{ mb: 3 }}
                            value={intOTP}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <LockOutlinedIcon color="action" />
                                </InputAdornment>
                              ),
                            }}
                            onChange={(e) => setOTP(e.target.value)}
                            helperText={errors.txtEmail?.message}
                            error={errors.txtEmail?.message ? true : false}
                          />
                          {errMessage && (
                            <Typography
                              color="error"
                              variant="body2"
                              sx={{ mb: 2 }}
                            >
                              {errMessage}
                            </Typography>
                          )}
                          <LoadingButton
                            fullWidth
                            size="large"
                            variant="contained"
                            color="primary"
                            sx={{
                              py: 1.5,
                              mb: 2,
                              textTransform: "none",
                              fontSize: "16px",
                              fontWeight: 600,
                            }}
                            onClick={handleVerifyOTP}
                            disabled={formState.isSubmitting}
                          >
                            Verify OTP
                          </LoadingButton>
                          <Box sx={{ textAlign: "center" }}>
                            <Typography
                              variant="body2"
                              color="primary"
                              sx={{ cursor: "pointer" }}
                              onClick={() => setIsSendOTP(!isSendOTP)}
                            >
                              Change email address
                            </Typography>
                          </Box>
                        </Box>
                      </Fade>
                    ) : isForgotPin ? (
                      <Fade in={true}>
                        <Box>
                          <Box sx={{ textAlign: "center", mb: 4 }}>
                            <LockOutlinedIcon
                              sx={{ fontSize: 56, color: "#fff", mb: 2 }}
                            />
                            <Typography
                              variant="h5"
                              fontWeight={600}
                              gutterBottom
                            >
                              Welcome To LMGG
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Enter your 4-digit PIN to continue
                            </Typography>
                          </Box>
                          <Stack
                            direction="row"
                            spacing={2}
                            justifyContent="center"
                            sx={{ mb: 4 }}
                          >
                            {otp.map((data, index) => {
                              return (
                                <input
                                  className="otp-field"
                                  type="text"
                                  name="otp"
                                  maxLength="1"
                                  key={index}
                                  value={data}
                                  clearinput
                                  onChange={(e) =>
                                    handleChangesubmit(e.target, index)
                                  }
                                  onFocus={(e) => e.target.select()}
                                  onKeyDown={(e) =>
                                    handlePinBackspace(e, index)
                                  }
                                  onPaste={(e) => handlePaste(e, index, "otp")}
                                />
                              );
                            })}
                          </Stack>
                          {errMessage && (
                            <Typography
                              color="error"
                              variant="body2"
                              sx={{ mb: 2, textAlign: "center" }}
                            >
                              {errMessage}
                            </Typography>
                          )}

                          {/* <p>PIN Entered - {otp.join("")}</p> */}
                          <Box sx={{ textAlign: "center" }}>
                            <Typography
                              variant="body2"
                              color="primary"
                              sx={{
                                cursor: "pointer",
                                fontWeight: 700,
                                textDecoration: "underline",
                              }}
                              onClick={handleForgotPin}
                            >
                              Forgot your PIN?
                            </Typography>
                          </Box>
                        </Box>
                      </Fade>
                    ) : (
                      <Fade in={true}>
                        <Box>
                          <IconButton onClick={handleForgotPin} sx={{ mb: 2 }}>
                            <ArrowBackIcon />
                          </IconButton>
                          <Box sx={{ mb: 4 }}>
                            <Typography
                              variant="h5"
                              fontWeight={600}
                              gutterBottom
                            >
                              Forgot PIN
                            </Typography>
                            <Typography variant="body2" color="text.secondary">
                              Enter your registered email address to receive an
                              OTP
                            </Typography>
                          </Box>
                          <TextField
                            name="txtEmail"
                            type="text"
                            label="Email"
                            fullWidth
                            value={forgotPasswordEmail}
                            onChange={(e) =>
                              setForgotPasswordEmail(e.target.value)
                            }
                            sx={{
                              mb: 3,
                              "& .MuiOutlinedInput-root": {
                                "& fieldset": {
                                  borderColor: "#fff", // normal
                                },
                                "&:hover fieldset": {
                                  borderColor: "#fff", // hover
                                },
                                "&.Mui-focused fieldset": {
                                  borderColor: "#fff", // focus
                                },
                              },
                              "& .MuiInputLabel-root": {
                                color: "#fff", // label color
                              },
                              "& .MuiInputLabel-root.Mui-focused": {
                                color: "#fff",
                              },
                            }}
                            InputProps={{
                              startAdornment: (
                                <InputAdornment position="start">
                                  <EmailOutlinedIcon sx={{ color: "#fff" }} />
                                </InputAdornment>
                              ),
                            }}
                          />
                          {errors.txtEmail?.message && (
                            <Typography className="invalid-feedback">
                              {errors.txtEmail?.message}
                            </Typography>
                          )}

                          {errMessage && (
                            <Typography
                              color="error"
                              variant="body2"
                              sx={{ mb: 2 }}
                            >
                              {errMessage}
                            </Typography>
                          )}
                          <Box sx={{ textAlign: "center" }}>
                            <LoadingButton
                              fullWidth
                              size="large"
                              variant="contained"
                              onClick={handleSendOTP}
                              disabled={formState.isSubmitting}
                              sx={{
                                py: 1.5,
                                mb: 2,
                                textTransform: "none",
                                backgroundColor: "#fff",
                                color: "#9a2728",
                                fontSize: "16px",
                                fontWeight: 600,
                              }}
                            >
                              Send OTP
                            </LoadingButton>
                          </Box>
                          <Box sx={{ textAlign: "center" }}>
                            <Typography
                              variant="body2"
                              color="primary"
                              sx={{ cursor: "pointer", fontWeight: 600, textDecoration: "underline" }}
                              onClick={handleForgotPin}
                            >
                              Back to PIN login
                            </Typography>
                          </Box>
                        </Box>
                      </Fade>
                    )}
                  </Box>
                </Grid>
              </Grid>
            </Paper>
          </Fade>
        </Container>
      </Box>
    </>
  );
}
